import Routes from "./pages/routes";
import NavBar from './components/NavBar';
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div className="App">
      <LoadingSpinner/>
      <NavBar/>
      <Routes />
      <ToastContainer />
    </div>
  );
}

export default App;
